import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const Card = styled.div`
  max-width: 1022px;
  border: 1px solid #e3e1e1;
  border-radius: 4px;
  padding: 48px;
  background: #fff;
  margin: 32px 0;
`;

export const Heading = styled.h1`
  font-size: 18px;
  color: #4b4d4e;
  font-weight: 700;
  margin: 0 0 32px 0;
`;

export const SubHeading = styled.h2`
  font-size: 16px;
  font-weight: 400;
  color: #444444;
  margin: 0 0 24px 0;
`;

export const Services = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  > * {
    width: 100%;
  }

  @media (min-width: 950px) {
    > * {
      width: 48%;
    }
  }
`;

export const StyledService = styled.div`
  background: #F4F5F7;
  padding: 18px 24px 24px 42px;
  box-sizing: border-box;
  position: relative;
  margin-bottom: 32px;
  border-radius: 4px;

  i {
    position: absolute;
    display: block;
    width: 18px;
    left: 14px;
    top: 22px;
    color: #6C727F;
  }

  h3 {
    font-size: 18px;
    font-weight: 700;
    color: #26282B;
    margin: 0 0 14px 0;
  }

  p {
    font-size: 14px;
    color: #494F5A;
    margin: 0;
  }
`;
